import { Component, ViewChild, Injector, Output, EventEmitter, OnInit, ElementRef } from '@angular/core';
import { finalize } from 'rxjs/operators';
import {
    ChartOfAccountsServiceProxy,
    CreateOrEditChartOfAccountDto,
    ChartOfAccountAccountGroupLookupTableDto,
    ChartOfAccountAccountSubGroupLookupTableDto,
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';
import { ActivatedRoute, Router } from '@angular/router';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Observable } from '@node_modules/rxjs';
import { BreadcrumbItem, SubHeaderComponent } from '@app/shared/common/sub-header/sub-header.component';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

@Component({
    templateUrl: './create-or-edit-chartOfAccount.component.html',
    animations: [appModuleAnimation()],
    standalone: false,
})
export class CreateOrEditChartOfAccountComponent extends AppComponentBase implements OnInit {
    active = false;
    saving = false;

    chartOfAccount: CreateOrEditChartOfAccountDto = new CreateOrEditChartOfAccountDto();

    accountGroupName = '';
    accountSubGroupName = '';

    allAccountGroups: ChartOfAccountAccountGroupLookupTableDto[];
    allAccountSubGroups: ChartOfAccountAccountSubGroupLookupTableDto[];

    breadcrumbs: BreadcrumbItem[] = [
        new BreadcrumbItem(this.l('ChartOfAccount'), '/app/account/chartOfAccounts'),
        new BreadcrumbItem(this.l('Entity_Name_Plural_Here') + '' + this.l('Details')),
    ];

    constructor(
        injector: Injector,
        private _activatedRoute: ActivatedRoute,
        private _chartOfAccountsServiceProxy: ChartOfAccountsServiceProxy,
        private _router: Router,
        private _dateTimeService: DateTimeService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.show(this._activatedRoute.snapshot.queryParams['id']);
    }

    show(chartOfAccountId?: number): void {
        if (!chartOfAccountId) {
            this.chartOfAccount = new CreateOrEditChartOfAccountDto();
            this.chartOfAccount.id = chartOfAccountId;
            this.accountGroupName = '';
            this.accountSubGroupName = '';

            this.active = true;
        } else {
            this._chartOfAccountsServiceProxy.getChartOfAccountForEdit(chartOfAccountId).subscribe((result) => {
                this.chartOfAccount = result.chartOfAccount;

                this.accountGroupName = result.accountGroupName;
                this.accountSubGroupName = result.accountSubGroupName;

                this.active = true;
            });
        }
        this._chartOfAccountsServiceProxy.getAllAccountGroupForTableDropdown().subscribe((result) => {
            this.allAccountGroups = result;
        });
        this._chartOfAccountsServiceProxy.getAllAccountSubGroupForTableDropdown().subscribe((result) => {
            this.allAccountSubGroups = result;
        });
    }

    save(): void {
        this.saving = true;

        this._chartOfAccountsServiceProxy
            .createOrEdit(this.chartOfAccount)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe((x) => {
                this.saving = false;
                this.notify.info(this.l('SavedSuccessfully'));
                this._router.navigate(['/app/account/chartOfAccounts']);
            });
    }

    saveAndNew(): void {
        this.saving = true;

        this._chartOfAccountsServiceProxy
            .createOrEdit(this.chartOfAccount)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe((x) => {
                this.saving = false;
                this.notify.info(this.l('SavedSuccessfully'));
                this.chartOfAccount = new CreateOrEditChartOfAccountDto();
            });
    }

    goBack(): void{
        this._router.navigate(['/app/account/chartOfAccounts']);
    }
}
